import React from 'react';
import logo from "../assets/logo-normal.png";



export default () => <img src={logo} alt="Hotel Villiam logo" className="inline-logo xs"/>